var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dcw-error"},[_c('DcwHeader'),_vm._v(" "),_c('Errors',{attrs:{"content":_vm.content,"status-code":_vm.error && _vm.error.statusCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }